function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M8 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0m16 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-14.5-.5a.5.5 0 0 0 0 1H12v.932a.5.5 0 0 0 .82.385l1.72-1.433a.5.5 0 0 0 0-.768l-1.72-1.433a.5.5 0 0 0-.82.385v.932z",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/favourite/ic-favourite-trip.svg";
export { SvgComponent as ReactComponent };